import React from 'react';
import styled from 'styled-components';
import {
  brandColours,
  fontSize,
  fontWeights,
  minBreakpointQuery,
  standardColours,
} from '../styles';

const StyledCustomerReviewCard = styled.article`
  display: flex;
  flex-direction: column;
  padding: 10px 30px 25px;
  color: ${brandColours.septenary};
  border: 1px solid ${standardColours.grey};
  border-radius: 3px;
`;

const StyledTop = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid ${standardColours.grey};

  ${minBreakpointQuery.small`
    gap: 20px;
  `}
`;

const StyledInitials = styled.span`
  display: block;
  height: 40px;
  width: 40px;
  font-weight: ${fontWeights.bold};
  ${fontSize(17)};
  line-height: 40px;
  text-align: center;
  background-color: ${brandColours.senary};
  border-radius: 50%;

  ${minBreakpointQuery.small`
    height: 48px;
    width: 48px;
    ${fontSize(20)};
    line-height: 48px;
  `}
`;

const StyledName = styled.p`
  font-weight: ${fontWeights.bold};
  ${fontSize(14)};

  ${minBreakpointQuery.small`
    ${fontSize(16)};
  `}
`;

const StyledHeading = styled.h3`
  ${fontSize(18)};

  ${minBreakpointQuery.small`
    ${fontSize(20)};
  `}
`;

const StyledQuote = styled.blockquote`
  margin: 10px 0 0;
`;

const StyledText = styled.p`
  ${minBreakpointQuery.small`
    ${fontSize(18)};
  `}
`;

const StyledDate = styled.p`
  margin-top: auto;
  padding-top: 30px;
  ${fontSize(14)};

  ${minBreakpointQuery.small`
    ${fontSize(16)};
  `}

  span {
    font-weight: ${fontWeights.bold};
  }
`;

const CustomerReviewCard = ({
  name,
  heading,
  quote,
  dateOfExperience,
  ...props
}) => {
  const getInitials = name => {
    const names = name.split(' ');
    const initials = names
      .map(part => part[0].toUpperCase())
      .join('')
      .slice(0, 2);

    return initials;
  };

  const initials = getInitials(name);

  return (
    <StyledCustomerReviewCard {...props}>
      <StyledTop>
        <StyledInitials>{initials}</StyledInitials>
        <StyledName>{name}</StyledName>
      </StyledTop>
      <StyledHeading>{heading}</StyledHeading>
      <StyledQuote>
        <StyledText>{quote.quote}</StyledText>
      </StyledQuote>
      <StyledDate>
        <span>Date of experience:</span> {dateOfExperience}
      </StyledDate>
    </StyledCustomerReviewCard>
  );
};
export default CustomerReviewCard;
